import strings from 'utils/strings'
import {
  ALL,
  PTO1,
  PTO2,
  PTO3,
  EMPTO1,
  EMPTO2,
  EMPTO,
  SUMMARY,
  ALL_DOMAINS,
  ENGINE_SPEED_SETTINGS,
} from 'constants/ui/ptoDiagram'
import { mapFrom } from 'utils/functional'

export const fragmentBooleanText = (value) => (value ? strings.on : strings.off)

export const ptoFilterText = mapFrom({
  [ALL]: strings.pto_diagram_all,
  [PTO1]: strings.pto1,
  [PTO2]: strings.pto2,
  [PTO3]: strings.pto3,
  [EMPTO1]: strings.empto1,
  [EMPTO2]: strings.empto2,
  [EMPTO]: strings.empto,
})

export const summaryFilterText = mapFrom({
  [PTO1]: strings.pto1_summary,
  [PTO2]: strings.pto2_summary,
  [EMPTO]: strings.empto_summary,
})

export const toggleViewText = mapFrom({
  [SUMMARY]: strings.pto_settings_summary,
  [ALL_DOMAINS]: strings.all_pto_settings,
  [ENGINE_SPEED_SETTINGS]: strings.engine_speed_settings,
})
